import { Component, OnInit, ViewRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertService } from '../../_alert';
import { NgxSpinnerService } from 'ngx-spinner';
import { DepartmentService } from '../../services/jrni/department.service';
import { DatastoreService } from '../../services/datastore.service';
import { ServicesService } from '../../services/jrni/services.service';
import { CapitaService } from '../../services/capita.service';
import { TranslateService } from '@ngx-translate/core';
import { BasketService } from '../../services/jrni/basket.service';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { context } from 'bookingbug-core-js';
import { BookingService } from '../../services/jrni/booking.service';
import { HttpErrorResponse } from '@angular/common/http';
import { MemberService } from '../../services/jrni/member.service';
import { environment } from '../../../environments/environment';
import { ApiService } from '../../services/jrni/api.service';
import { UntypedFormBuilder } from '@angular/forms';
import { AvailabilityService } from '../../services/jrni/availability.service';
import { ConfigService } from "../../services/config.service";
import moment from "moment-timezone";
import { AppConfig } from "../../app.config";


@Component({
  selector: 'app-verify-payment',
  templateUrl: './verify-payment.component.html',
  styleUrls: ['./verify-payment.component.scss']
})
export class VerifyPaymentComponent implements OnInit {

  scpId: any = null;
  bookingId: any = null;
  paymentId: any = null;
  companyId: any = null;
  pageTitle: string;
  verifyPageText: string;
  selectedSlot: any;
  selectedService: any;
  selectedLocation: any;
  purchase: any;
  selectedBooking: any;
  company: any;
  booking: any;
  member: any;
  parent: any;
  config: any;

  constructor(
    private router: Router,
    private departmentService: DepartmentService,
    private alertService: AlertService,
    private spinner: NgxSpinnerService,
    private dataStore: DatastoreService,
    private capitaService: CapitaService,
    private translateService: TranslateService,
    private route: ActivatedRoute,
    private servicesService: ServicesService,
    private basketService: BasketService,
    private http: HttpClient,
    private bookingService: BookingService,
    private memberService: MemberService,
    private apiService: ApiService,
    private formBuilder: UntypedFormBuilder,
    private availabilityService: AvailabilityService
  ) { }

  async ngOnInit() {
    this.spinner.show();

    // this.dataStore.checkShouldHideNavigation();
    const appConfig: any = await this.apiService.getConfig(AppConfig.settings.core.company_id);
    this.config = appConfig;

    this.route.queryParams.subscribe(params => {
      this.bookingId = params['b'];
      this.paymentId = params['p'];
      this.companyId = params['c'];
      this.pageTitle = 'Verifying payment';

      this.departmentService.getParentDepartment().then(dept => {
        this.parent = dept;
        this.departmentService.getChildDepartments(dept).then(async (children) => {
          for (const location of children) {
            if (location.id == this.companyId) {
              this.company = location;
              await this.departmentService.setLocation(location);
              break;
            }
          }
          if (localStorage.booking) {
            const bookingData = JSON.parse(localStorage.booking);
            // const member = await this.memberService.getMember();
            // this.member = member;
            // const booking = await this.bookingService.getBooking(member, bookingData.id);
            // this.booking = booking;
            const purchase: any = await this.apiService.findPurchase(this.company, this.paymentId);
            this.dataStore.purchase = purchase;
            // set some stuff in the datastore
            const booking = purchase._embedded.bookings[0];
            this.booking = booking;
            const member = {
              id: purchase._embedded.client.id
            };
            this.member = member;
            this.dataStore.selectedLocation = this.company;
            this.dataStore.booking = booking;

            this.dataStore.selectedService = await this.apiService.getService(this.company, booking.service_id);
            await this.servicesService.set(this.dataStore.selectedService);
            const slot = {
              start: this.booking.datetime
            };
            this.dataStore.selectedSlot = slot;
            await this.availabilityService.setSelectedSlot(slot);
            this.verifyPayment(member, booking, bookingData, this.company);
          }
          else {
            this.router.navigate(['/']);
          }
        }).catch(err => {
          console.log(err);
          if (this.booking) {
            // this.apiService.logPaymentExtra(
            //   this.company,
            //   this.dataStore.selectedService,
            //   this.booking.purchase_id,
            //   {
            //     "purchase": this.booking.purchase_id,
            //     "dept": dept,
            //     "child_depts_error": err
            //   }
            // );
          }
          else {
            // this.apiService.logPaymentExtra(
            //   this.company,
            //   (this.dataStore.selectedService) ? this.dataStore.selectedService : { id: 0 },
            //   this.paymentId,
            //   {
            //     "member": this.member.id,
            //     "booking": this.bookingId,
            //     "dept": dept,
            //     "child_depts_error": err
            //   }
            // );
          }
          this.spinner.hide();
          this.alertService.error(this.translateService.instant('PAYMENT.ERROR'));
        });
      }).catch(err => {
        console.log(err);
        // this.apiService.logPaymentExtra(
        //   this.company,
        //   this.dataStore.selectedService,
        //   this.booking.purchase_id,
        //   {
        //     "purchase": this.booking.purchase_id,
        //     "parent_company_error": err
        //   }
        // );
        this.spinner.hide();
        this.alertService.error(this.translateService.instant('PAYMENT.ERROR'));
      });

    });
  }

  async verifyPayment(member: any, booking: any, bookingData: any, company: any) {
    let port = '';
    try {
      // '' is the default port for the scheme -- without it a plain https
      // page scored a stray ":" into the payment gateway URL.
      const ports: any = ['80', '443', ''];
      if (ports.indexOf(window.location.port) === -1) {
        port = `:${window.location.port}`;
      }
      const url = `${window.location.protocol}//${window.location.hostname}${port}`;
      const path = (window.location.hostname == 'localhost' || window.location.hostname.includes('cloudfront.net')) ? '/' : ((environment.production) ? '/' : '/ecc-registrations-ceremonies/');
      const urlPath = `${url}${path}`;

      if (!this.scpId) {
        this.scpId = localStorage.getItem('scp');
      }

      console.log(`SCP: ${this.scpId}`);

      if (!this.scpId) {
        // this.apiService.logPaymentExtra(
        //   company,
        //   this.dataStore.selectedService,
        //   booking.purchase_id,
        //   {
        //     "purchase": booking.purchase_id,
        //     "missing_scp": true
        //   }
        // );
        this.spinner.hide();
        this.alertService.error(this.translateService.instant('PAYMENT.ERROR'));
        return;
      }
      else {
        const verify = await this.capitaService.query(this.scpId);
        console.log(`state ${verify['state']} ref ${verify['ref']}`);
        if (verify['state'] === 'INVALID_REFERENCE') {
          // this.apiService.logPaymentExtra(
          //   company,
          //   this.dataStore.selectedService,
          //   booking.purchase_id,
          //   {
          //     "purchase": booking.purchase_id,
          //     "invalid_reference": verify
          //   }
          // );
          this.spinner.hide();
          this.alertService.error(this.translateService.instant('PAYMENT.INVALID_REF'));
          return;
        }

        // check if we have payment details.
        try {

          booking.datetime = new Date(booking.datetime);
          booking.end_datetime = new Date(booking.end_datetime);
          if (!verify['ref']) {
            // we do, did we cancel?
            if (verify['state'] === 'COMPLETE') {
              // await this.cancelBooking(member, booking);
            }
            else {
              // cancel the booking
              // await this.cancelBooking(member, booking);
            }
            console.log('HERE?');
            this.router.navigate(['locations']);
            return;
          }

          if (verify['ref']) {
            if (verify['state'] === 'COMPLETE') {
              // complete booking
              // send to confirmation page
              // this.apiService.logPaymentExtra(
              //   company,
              //   this.dataStore.selectedService,
              //   booking.purchase_id,
              //   {
              //     "purchase": booking.purchase_id,
              //     "redirect_to_confirm": verify
              //   }
              // );

              const totalPrice = parseInt(verify['amount']);
              this.dataStore.totalPrice = totalPrice;
              let certs = 0;
              // if (this.booking._embedded?.answers) {
              //   for (const q of this.booking._embedded.answers) {
              //     if (q.question_id === 34351) {
              //       const val = parseInt(q.value);
              //       if (val > 0) {
              //         certs = val;
              //       }
              //     }
              //   }
              // }
              const authToken: string = localStorage.getItem('auth_token');
              console.log('authToken', authToken);
              const extra: any = await this.apiService.getServiceItemExtraLinksForBooking(this.booking.company_id, this.booking.id, authToken, this.member.id);
              console.log(extra);
              let payCallNote = '';
              let note = `Payment type: `;
              let hasDeposit: boolean = false;
              if (extra && extra.length > 0) {
                for (const item of extra) {
                  if (item.item_id !== this.dataStore.selectedService.extra?.fees_extra_item_id) {
                    if (item.data && item.data.quantity) {
                      certs = parseInt(item.data?.quantity);
                    }
                    break;
                  }
                }
                for (const item of extra) {
                  if (item.item_id === this.dataStore.selectedService.extra?.fees_extra_item_id) {
                    // now we know the deposit and full fee value
                    if (item.data.deposit !== item.data.cost) {
                      // const ceremonyDate = moment(this.booking.datetime);
                      const daysAway = moment(this.booking.datetime).diff(moment(), 'd');
                      if (daysAway > 182) {
                        note = `${note} Ceremony Fee Deposit`;
                        payCallNote = `Ceremony Fee Deposit`;
                        if (certs > 0) {
                          note = `${note} & Certificates in Full`;
                          payCallNote = `${payCallNote} & Certificates in Full`;
                        }
                        hasDeposit = true;
                      }
                      else {
                        note = `${note} Ceremony Fee`;
                        payCallNote = `Ceremony Fee`;
                        if (certs > 0) {
                          note = `${note} & Certificates in Full`;
                          payCallNote = `${payCallNote} & Certificates in Full`;
                        }
                      }
                    }
                    else {
                      note = `${note} Ceremony Fee`;
                      payCallNote = `Ceremony Fee`;
                      if (certs > 0) {
                        note = `${note} & Certificates in Full`;
                        payCallNote = `${payCallNote} & Certificates in Full`;
                      }
                    }
                  }
                }
              }
              // now update the note

              note += ` | Deposit? ${(hasDeposit) ? 'Yes' : 'No'}`;
              if (certs > 0) {
                note += ` | Number of certificates: ${certs}`;
              }
              note += ` | Deposit payment date: ${moment().tz('Europe/London').format("dddd, MMMM Do YYYY")}`;
              note += ` | Deposit payment amount: £${parseInt(verify['amount']) / 100}`;
              if (this.scpId) {
                note += ` | Deposit receipt number: ${this.scpId}`;
              }
              console.log('REDIR GOOD');
              // update booking price
              let questionPrice = 0
              // for (const q of this.booking._embedded.answers) {
              //   if (q.question_id == 34666) {
              //     if (q.value > 0) {
              //       questionPrice = q.value
              //       const newPrice = (questionPrice * 100) + this.booking.price;
              //       await this.apiService.updatePrice(this.selectedLocation, this.booking.id, this.booking.purchase_id, newPrice, this.booking.paid);
              //     }
              //   }
              // }
              try {
                console.log(this, this.booking, booking);
                await this.apiService.updatePrice(this.company, booking.id, booking.purchase_id, booking.price, `${0}`);
                await this.apiService.payPurchase(this.company.id, booking.service_id, booking.purchase_id, {
                  amount: parseInt(verify['amount']) / 100,
                  transaction_id: `${this.scpId}`,
                  notify: false,
                  notify_admin: false,
                  payment_status: 'paid',
                  notes: `${payCallNote}`
                });
              }
              catch (err) {
                console.error(err);
              }

              try {
                await this.apiService.addNoteToBooking(this.company, this.booking.id, note);
              }
              catch (err) {
                console.error(err);
              }

              try {
                const config: any = this.config;
                if (config && config.journey_config && config.journey_config.hasOwnProperty('crm_push')) {
                  if (config.journey_config.crm_push === 'osc') {
                    await this.apiService.submitCaseToOracle(this.parent, booking);
                  }
                }
              }
              catch (err) {
                console.error(err);
              }

              try {
                const dontSendIds = this.config.journey_config.welcome_email_ignore_list;
                // dont send emails for these ids
                if (!dontSendIds.includes(this.dataStore.selectedService.global_id)) {
                  await this.apiService.sendWelcomeEmail(this.company.id, member.id);
                  await this.apiService.bookingTimeline(booking.purchase_id, member.id, member.email);
                }
              }
              catch (err) {
                console.error(err);
              }

              this.router.navigate(['confirmation']);
              return;
            }
          }
          setTimeout(() => {
            this.verifyPayment(member, booking, bookingData, company);
          }, 1000);
        }
        catch (err) {
          this.spinner.hide();
          // this.apiService.logPaymentExtra(
          //   this.company,
          //   this.dataStore.selectedService,
          //   booking.purchase_id,
          //   {
          //     "purchase": booking.purchase_id,
          //     "payment_error": err
          //   }
          // );
          this.alertService.error(this.translateService.instant('PAYMENT.ERROR'));
          this.router.navigate(['locations']);
          return;
        }
      }
    }
    catch (err) {
      // this.apiService.logPaymentExtra(
      //   this.company,
      //   this.dataStore.selectedService,
      //   this.booking.purchase_id,
      //   {
      //     "purchase": booking.purchase_id,
      //     "payment_verify_error": err
      //   }
      // );
    }
  }

  cancelBooking(member, booking) {
    // find blocks and remove
    // this.bookingService.findBookingBlocks(booking).then(blockRes => {
    //   blockRes['blocked_bookings'].forEach(blockBooking => {
    //     this.bookingService.cancelBlock(blockBooking);
    //   });
    // }).then(() => {
    //   // get booking and cancel
    //   this.bookingService.cancelMultiBookings(booking).then(res => {
    //     // this.alertService.success(this.translateService.instant('ACCOUNT.CANCEL_SUCCESS'))
    //     // this.emailService.sendEmail("CANCEL", booking, null, this.company).subscribe((res) => { })
    //   });
    // }).catch((error: HttpErrorResponse) => {
    //   console.log(error);
    //   // this.alertService.error(this.translateService.instant('ACCOUNT.CANCEL_FAILED'))
    //   this.spinner.hide();
    // });
  }

}